import React from 'react';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AvariceLogo from "./assets/avarice-logo.png";
import MesoverseLogo from "./assets/Mesoverse-Logo.png";
import Konjur3DLogo from "./assets/konjur3d-logo.png";

class Products extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {
    return (
        <div>
    <div className="product-background">  
    </div>

    <div className="intro-shield">
    </div>

    <div className="content" style={{ marginTop: "150px"}}>
      <h2>
        PRODUCTS&nbsp;&nbsp;&nbsp;
      </h2>
      <h3>
        Our Platforms
      </h3>
    </div>
    
      <div className="content" style={{ width: "calc(100vw)", minHeight: "100vh", marginLeft: "0px", paddingTop: "50px", paddingLeft: "100px", paddingRight: "100px", marginRight: "0px", marginTop: "17vh", backgroundColor: "#000000", borderRadius: "0px" }}>
        <div>
          <h4><a href="https://www.avarice.co.za" target="_blank"><img className="product-logo-1" src={AvariceLogo}/></a></h4>
        <h5>FUTURE ERP</h5>
          <p>
            Avarice is our premier ERP (Enterprise Resource Planning) solution designed with completeness and low/no code configuration in mind.  It provides
          accounting, procurement, customer relationship management (CRM) and human resources (HR) modules which are tuned to specific customer needs.  The system 
          is also used to support financial functions such as payment and debit orders.
        </p>  
        <h5>CONFIGURABLE</h5>
        <p>
          The architecture is highly 
            configurable through our Ropes graphical languages (a low-code environment).  This enables a high level of automation.  With build-in UI path 
          and document processing tools many workflows can be left to the machine to process itself.  It has many standard libraries for interfacing with
          other major systems should such interaction be necessary.  
        </p>
        <p>
          It consists of three main components:  Avarice Accounting, Avarice Forms and Avarice Procure.
          </p>
        <h5>ACCOUNTING</h5>
          <p>
            The accounting engine is a performance double-entry accounting solution which captures a complete financial
            statement from owner's equity to accounts payable.  This functions as the core of the system and enables a 
            business to capture its processes and data against the 'numbers.'  The accounting system will pay necessary 
            transactions on command and has a complete treasury cash management engine.
          </p>
        <h5>FLEXIBLE FORMS AND WORKFLOWS</h5>
        <p>
          Avarice Forms enables any workflow to be captured as a quick and easy form alongside its routing.  Approvals and signoff gatekeep
          forms from maturing to transactions.  The forms themselves can contain many types of questions, document attachments and are stored robustly to
          ensure all changes are recorded.  It serves human resources, legal and compliance functions easily.  A project/case management tool 
          ensures forms are executed by necessary stakeholders and progress can be dashboarded.  
          The system is dynamic enough to be used as a learning management system and tutorial provider for some of our clients.
        </p>
        <h5>ADVANCED PROCUREMENT</h5>
          <p>
            Avarice Procure is a complete procurement solution that can operate with or without accounting.  It handles everything from
            supplier vetting to payment.  The system is deployed in government and in large corporate operations where it serves to reduce
            paperwork and manual labor.  With a design philosophy centered on fraud prevention, most risks in supply chain are catered for
          in the design.
          </p>
          <div style={{ marginBottom: "100px", marginTop: "100px", textAlign: "center", width: "100%" }}><a href="https://www.avarice.co.za" target="_blank"><strong style={{ color: "#FFFFFF"}}><FontAwesomeIcon icon="chevron-right" />&nbsp;&nbsp;Avarice ERP Homepage</strong></a></div>
        </div>
      <div class="product-divider"></div>

      

        <div>
        <h4><a href="https://www.konjur3d.com" target="_blank"><img className="product-logo" src={Konjur3DLogo} /></a></h4>
          <h4>
            KONJUR3D
          </h4>
          <p>
           Konjur3D is an iPad based 3D modelling tool that is simple to use and powerful.  It is best used with an Apple Pencil.  Clay,
         hard surface and 'from the block' modelling.  The editor has a built in texture editor and texture mapping tools.  It can export to 
         OBJ, GLTF and USDZ (for AR tools).
          </p>
        <div style={{ marginBottom: "100px", marginTop: "100px", textAlign: "center", width: "100%" }}><a href="https://www.konjur3d.com" target="_blank"><strong style={{ color: "#FFFFFF"}}><FontAwesomeIcon icon="chevron-right" />&nbsp;&nbsp;Konjur3D Homepage</strong></a></div>
        </div>
      <div class="product-divider"></div>
        <div>  
          <h4>
            WRATH
          </h4>
          <p style={{ marginBottom: "100px" }}>
            We are currently developing a 3D graphics/large-scale network engine for VR and AR applications, particularly in business.  (Yes, another one, we know there are many out there.)  
          The system is completely platform agnostic and can be used in game development.  Speak to us for more information.
          </p>
        </div>

      <div class="product-divider"></div>

      <div>
          <h4>{/*<a href="https://www.mesoverse.net" target="_blank">*/}<img className="product-logo" src={MesoverseLogo} />{/*</a>*/}</h4>
        <h4>RELENTLESS UNIVERSE</h4>
          
        <h5>IT BEGAN IN INTERVIEW SURVEYING</h5>
          <p>
            Universe started life as a surveying tool used by interviewers to capture question and answer data.  These
            interviewees came from all walks of life.  The first survey executed by the system was a 80,000 point, 200 question 
            economic assessment of township enterprises in the Gauteng Province of South Africa.  This was executed in 2016.
            The system was then used to gather the 36,000 point Gauteng Central Region Observatory Quality-of-Life survey in 2018.
          </p>  
        <h5>SERVES TRADITIONAL BOOTS-ON-THE-GROUND BUSINESS MANAGEMENT</h5>  
          <p>
            After several rewrites and evolutions the system has become a comprehensive form and flow based
            business management tool, complete with productivity elements such as calendars and chat.  It is actively used by
            many businesses in South Africa under various white labels in industries that range from merchandising to 
            municipal permits.
          </p>
        <h5>ENABLES GIG ECONOMY</h5>
        <p>
          Beyond business management, the system facilitates gig economy ventures, automating transactions and interactions with customers.
          If you canvas a business flow the system will realize it as a dashboard and the necessary apps for the Google Play Store and Apple App Store platforms.
          We are trialing this form of the system in several ventures as a generalized tool for decentralized business.  
        </p>
          <div style={{ marginBottom: "100px", marginTop: "100px", textAlign: "center", width: "100%" }}>{/*<a href="https://www.mesoverse.net" target="_blank">*/}<strong style={{ color: "#FFFFFF"}}><FontAwesomeIcon icon="chevron-right" />&nbsp;&nbsp;Mesoverse Homepage</strong>{/*</a>*/}</div>
        </div>
      </div>   
      </div>       
    );
  }
}

export default Products;